import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Button} from "reactstrap";
import Action from "../../Models/Action";

interface Props {
  action: Action;
  data?: Object
  size?: string;
}

const ButtonAction: React.FC<Props> = ({action, data, size = "sm"}) => {
  return (
    <Button size={size} outline={action.outline} disabled={action.disabled}  color={action.color} onClick={() => action.onClick && action.onClick(data)}>
      {
        action.icon && <FontAwesomeIcon className={action.label ? 'mr-2' : ''} icon={action.icon}/>
      }
      {
        action.label && <span>{action.label}</span>
      }
    </Button>
  );
};

export default ButtonAction;
